<div *ngIf="showAnfrageInfo && anfrage" class="information-card">
    <div class="top-bar">
        <h2 class="project-title">{{title}}</h2>
        <div class="top-bar-right" *ngIf="FreigabeAktiviert">
            <app-live-users-dialog></app-live-users-dialog>
            <button type="button" class="share-button" kendoButton (click)="openFreigebenDialog()"
                [title]="'application.share' | translate"> <span class="k-icon k-i-share"></span>
            </button>

        </div>
    </div>
    <main>
        <div class="information-card">
            <kendo-label class="title" text="{{'enquiry-card.area' | translate }}"></kendo-label>
            <span class="content form-label">{{bereich}}</span>
            <hr />
            <kendo-label class="title" text="{{'enquiry-card.tender' | translate}}"></kendo-label>
            <span class="content form-label">{{ausschreibung}}</span>
            <hr />
            <kendo-label class="title" text="{{'enquiry-card.phase' | translate}}"></kendo-label>
            <span class="content form-label">{{phase}}</span>
        </div>
    </main>
</div>